import React, { useCallback, useState } from "react";
import image4 from "../assets/storyy_img.png";
import { Link } from "react-router-dom";
import image1 from "../assets/zap.svg";
import image2 from "../assets/tool-01.svg";
import image3 from "../assets/chart-breakout-square.svg";

export default function Page2() {
  const truncateText = useCallback((text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  }, []);

  const [showMore, setShowMore] = useState(true);
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div>
      <div className="text-center  custom_card_main_container">
        <h4>Key Benefits</h4>
        <h1 className="pt-1">Why Andromeda-Sim?</h1>
        <h5 className="pt-2">
          Powering smarter, safer, and more efficient simulator operations.
        </h5>
        <div className="flex d-flex flex-column flex-md-row justify-content-between py-5 card_main_div">
          <div className="card_page2">
            <div className="new_container_andromeda">
              {" "}
              <img
                src={image1}
                className="img-fluid"
                width={24}
                height={24}
                alt="Andromeda"
              />
            </div>
            <h4>Real-Time Monitoring</h4>
            <p>
              Track simulator performance effortlessly. All your data, in one
              dashboard.
            </p>
          </div>

          <div className="card_page2">
            <div className="new_container_andromeda">
              {" "}
              <img
                src={image2}
                className="img-fluid"
                width={24}
                height={24}
                alt="Andromeda"
              />
            </div>
            <h4>Maintenance Automation</h4>
            <p>
              Stay ahead with predictive alerts. Prevent downtime before it
              happens.
            </p>
          </div>

          <div className="card_page2">
            <div className="new_container_andromeda">
              {" "}
              <img
                src={image3}
                className="img-fluid"
                width={24}
                height={24}
                alt="Andromeda"
              />
            </div>
            <h4>Training Insights</h4>
            <p>
              Turn usage data into smarter training. Optimise every pilot
              session.
            </p>
          </div>
        </div>
      </div>

      <div className="custom-container1 ">
        <div className="d-flex flex-column flex-lg-row  page2">
          <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
            <div className="w-ful page2phr new_phra_andromeda">
              <h1 className="pb-4">
                <span>Our </span>Story
              </h1>
              <p>
                <span>Andromeda-Sim</span> is a leading software solutions provider
                specialising in monitoring and controlling simulator quality and
                performance. Our advanced standalone software is designed to
                meet the specific requirements of aviation training centres and
                operators, giving clients full ownership and control.
              </p>
              <br></br>
              <p>
                The system enables organisations to manage multiple technicians
                under a single platform, oversee simulator performance, and
                maintain comprehensive control over deployment and data.
              </p>
              <br></br>
              <p>
                With <span>Andromeda-Sim,</span> you can enhance efficiency, reduce downtime,
                and ensure consistent compliance — a robust solution built by
                industry experts to deliver unmatched performance, reliability,
                and independence.
              </p>

              <Link to="/request-demo">
                <button className="btn-home1  mt-2 mt-md-4 ">
                  Request a DEMO
                </button>
              </Link>
            </div>
          </div>

          <div className="col-12 col-lg-6 d-none d-md-block">
            <img
              src={image4}
              className=" h-100 w-100 image-new-page2__"
              alt="why Andromeda"
            />
          </div>
          <div className="col-12 col-lg-6 px-4 pb-6 d-block d-md-none py-5">
            <img
              src={image4}
              className="rounded-4 img-fluid"
              alt="why Andromeda"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
